"use client";

import { motion } from "framer-motion";
import { TrendingDown, Layers, HeartHandshake } from "lucide-react";

export default function PricingExplainer() {
  return (
    <section
      className="section-padding"
      style={{
        background: "linear-gradient(180deg, var(--color-bg-alt) 0%, var(--color-bg) 100%)",
      }}
    >
      <div className="section-inner" style={{ maxWidth: 900 }}>
        <h2 className="section-heading">
          How our{" "}
          <em style={{ fontFamily: "var(--font-heading)" }}>pricing works</em>
        </h2>
        <p className="section-subheading">
          Pricing is based on two things: included voice usage and the level of
          operational support behind each plan. As project complexity and support
          needs increase, higher-tier plans provide stronger economics, more
          included minutes, and deeper hands-on guidance.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: 24,
            marginBottom: 48,
          }}
        >
          {[
            {
              icon: TrendingDown,
              title: "Lower Rates at Scale",
              desc: "Higher monthly tiers unlock lower per-minute rates, making them a better fit for larger or more active projects.",
            },
            {
              icon: Layers,
              title: "Usage + Support",
              desc: "Plans reflect both included minutes and the operational resources behind each tier, not just call volume.",
            },
            {
              icon: HeartHandshake,
              title: "Stronger Economics",
              desc: "As your usage grows, your effective cost per minute drops. Higher plans deliver better economics and deeper project support.",
            },
          ].map((item, i) => (
            <motion.div
              key={item.title}
              className="card"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              style={{ textAlign: "center", padding: 32 }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: "var(--color-bg-alt)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <item.icon size={22} color="var(--color-text)" strokeWidth={1.6} />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "1.1rem",
                  marginBottom: 8,
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  fontSize: "0.88rem",
                  color: "var(--color-text-muted)",
                  fontWeight: 300,
                  lineHeight: 1.7,
                }}
              >
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
